import { render, staticRenderFns } from "./GoogleBind.vue?vue&type=template&id=1a5312e6"
import script from "./GoogleBind.vue?vue&type=script&lang=js"
export * from "./GoogleBind.vue?vue&type=script&lang=js"
import style0 from "./GoogleBind.vue?vue&type=style&index=0&id=1a5312e6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports